const apiConfigs = {
  "regional": {
    "apiHost": "https://api-test.mit.edu",
    "paths": {
      "apiPath": "mitid-v2",
      "digitalId": "digital-id-v1"
    }
  },
  "global": {
    "apiHost": "https://mitid-test.mit.edu/api",
    "paths": {
      "apiPath": "mitid/v2",
      "digitalId": "digital-id/v1"
    }
  }
};
export default apiConfigs;